import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAppSelector } from 'hooks/redux';
/**
 * *회원 인증
 */

// * children으로 태그로 감싸진 Component가 온다.
const AuthRoute = ({ children }) => {
  const user = useAppSelector((state) => state.userSlice.userInfor);
  const navigate = useNavigate();

  // Check the user is logged in or not.
  if (user) {
    global.user_id = user.user_id;
  } else {
    navigate('/login');
  }
  return user && user.user_id ? children : <Navigate to='/login' />;
};

export default AuthRoute;
